<header class="collection-header section-inset-y bg-primary text-light" [class.header--wide]="imageWide">
  <div class="container">
    @if (image) {
      <figure class="collection-header__figure" [class.col-sm-6]="!imageWide">
        <!--<img class="collection-header__figure__image" [src]="image.url" [alt]="image.altText || title" />-->
        <app-shopify-media-item
          class="collection-header__figure__image"
          [mediaItem]="shopifyMedia"
          [productImage]="false"
          [sizes]="{ xs: 12 }"
        ></app-shopify-media-item>
        <div class="collection-header__bottom-right" [class.d-none]="!imageWide">
          <div class="container">
            <ng-content [select]="[bottomRight]"></ng-content>
          </div>
        </div>
      </figure>
    }
    <div class="collection-header__content col-sm-6">
      <main class="collection-header__content__inner text-max-width-xs">
        <!--<strong class="fw-semi d-block" *ngIf="!imageWide">{{ 'collectie-singular-name' | fromDictionary }}</strong>-->
        @if (title) {
          <h1 class="mb-3" [class.mb-0]="!text">{{ title }}</h1>
        }
        @if (text) {
          <p class="mb-0 type-body-md">{{ text }}</p>
        }
      </main>
    </div>
  </div>
</header>
